// extracted by mini-css-extract-plugin
export default {"projectPage":"EmployeeProjects_projectPage__DV47X"};